/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import * as PropTypes from "prop-types";
import React from "react";

export function StreamBankAutoCompleteHeaderItem(props) {
	const {header = ''} = props?.item ?? {};
	return <div className={"sb-autocomplete-header-item"}>
		{header}
	</div>;
}

StreamBankAutoCompleteHeaderItem.propTypes = {item: PropTypes.any};